module.exports = __webpack_public_path__ + "img/vi.a1534caa.png";